import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchLegalSuccess, fetchLegalFailure } from '../slices/legalSlice';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8082';
const TERMS_VERSION = 'v1.0.0';

function* fetchLegalDocSaga(action) {
  const doc = action.payload;
  let endpoint = '';
  switch (doc) {
    case 'terms':
      endpoint = `/legal/terms?version=${TERMS_VERSION}`;
      break;
    case 'privacy':
      endpoint = `/legal/privacy?version=${TERMS_VERSION}`;
      break;
    case 'recordingConsent':
      endpoint = `/legal/recording-consent?version=${TERMS_VERSION}`;
      break;
    case 'paymentTerms':
      endpoint = `/legal/payment-terms?version=${TERMS_VERSION}`;
      break;
    case 'dataProcessing':
      endpoint = `/legal/data-processing?version=${TERMS_VERSION}`;
      break;
    default:
      yield put(fetchLegalFailure({ doc, error: 'Unknown legal document' }));
      return;
  }
  try {
    const res = yield call(fetch, `${API_BASE_URL}${endpoint}`);
    if (!res.ok) throw new Error('Failed to load document');
    const json = yield call([res, 'json']);
    const content = json.data?.content || '';
    yield put(fetchLegalSuccess({ doc, content }));
  } catch (error) {
    yield put(fetchLegalFailure({ doc, error: error.message || 'Unable to load document.' }));
  }
}

export function* legalSaga() {
  yield takeLatest('legal/fetchLegalStart', fetchLegalDocSaga);
}
